module.exports = __webpack_public_path__ + "assets/img/detail-logo.37f0eb81.png";